<div><h1>Edit Location</h1><LoaderOverlay :loading="loading"><LocationForm></LocationForm></LoaderOverlay></div>